import { FindifyDataContextType } from "@/contexts/FindifyDataContext";

export class PlaceColor {
    value: string;

    constructor(value: string) {
        this.value = value;
    }


    get() {
        return this.value;
    }
    withAlpha(alpha: number): string {
        const hexStr = alpha.toString(16).padStart(2, '0');
        return this.value.length > 7 ? `${this.value.slice(0, 7)}${hexStr}` : `${this.value}${hexStr}`;
    }

    solidAlphaWhiteBase(alpha: number): string {
        // Parse the original color value
        const red = parseInt(this.value.substr(1, 2), 16);
        const green = parseInt(this.value.substr(3, 2), 16);
        const blue = parseInt(this.value.substr(5, 2), 16);

        // Calculate the equivalent solid color
        const solidRed = Math.round((red * (255 - alpha) / 255) + (255 * (alpha / 255)));
        const solidGreen = Math.round((green * (255 - alpha) / 255) + (255 * (alpha / 255)));
        const solidBlue = Math.round((blue * (255 - alpha) / 255) + (255 * (alpha / 255)));


        // Convert the solid color to hexadecimal format
        const solidHex = `#${solidRed.toString(16).padStart(2, '0')}${solidGreen.toString(16).padStart(2, '0')}${solidBlue.toString(16).padStart(2, '0')}`;

        return solidHex;
    }
    solidAlphaBlackBase(alpha: number): string {
        // Parse the original color value
        const red = parseInt(this.value.substr(1, 2), 16);
        const green = parseInt(this.value.substr(3, 2), 16);
        const blue = parseInt(this.value.substr(5, 2), 16);

        // Calculate the equivalent solid color
        const solidRed = Math.round((red * (255 - alpha) / 255) + (0 * (alpha / 255)));
        const solidGreen = Math.round((green * (255 - alpha) / 255) + (0 * (alpha / 255)));
        const solidBlue = Math.round((blue * (255 - alpha) / 255) + (0 * (alpha / 255)));


        // Convert the solid color to hexadecimal format
        const solidHex = `#${solidRed.toString(16).padStart(2, '0')}${solidGreen.toString(16).padStart(2, '0')}${solidBlue.toString(16).padStart(2, '0')}`;

        return solidHex;
    }

}

export const PlaceColors = (findifyDataContext: FindifyDataContextType | null) => {
    // console.log('findifyDataContextColor', findifyDataContext?.workspace?.app_settings)
    const isDarkmodeEnabled = findifyDataContext?.darkMode;
    const colors = findifyDataContext?.visitWorkspaceSelected ? findifyDataContext?.workspace?.app_settings?.colors : {};
    if (isDarkmodeEnabled) {
        return {
            primary: new PlaceColor(colors?.main_color_dark ?? '#e85f4a'),
            secondary: new PlaceColor(colors?.secondary_color_dark ?? '#601b2d'),
            text: new PlaceColor(colors?.text_color_dark ?? '#FFFFFF'),
            background: new PlaceColor(colors?.background_color_dark ?? '#202020'),
            alternateListBG: new PlaceColor(colors?.alternate_list_bg_dark ?? '#00000050'),
            sidebarBackgroundColor: new PlaceColor(colors?.sidebar_background_color_dark ?? '#000000CF'),
            sidebarTextColor: new PlaceColor(colors?.sidebar_text_color_dark ?? '#000000CF'),
            bottomBar: new PlaceColor(colors?.bottom_bar_dark ?? '#000000CF'),
            bottomBarIcon: new PlaceColor(colors?.bottom_bar_icon_dark ?? '#000000CF'),
            bottomBarIconSelected: new PlaceColor(colors?.bottom_bar_icon_selected_dark ?? '#000000CF'),
            findifyPrimary: new PlaceColor('#e85f4a'),
            findifySecondary: new PlaceColor('#601b2d'),
        }
    } else {
        return {
            primary: new PlaceColor(colors?.main_color ?? '#e85f4a'),
            secondary: new PlaceColor(colors?.secondary_color ?? '#601b2d'),
            text: new PlaceColor(colors?.text_color ?? '#3e3836'),
            background: new PlaceColor(colors?.background_color ?? '#f4efea'),
            alternateListBG: new PlaceColor(colors?.alternate_list_bg ?? '#eee4de'),
            sidebarBackgroundColor: new PlaceColor(colors?.sidebar_background_color ?? '#f4efea'),
            sidebarTextColor: new PlaceColor(colors?.sidebar_text_color ?? '#3e3836'),
            bottomBar: new PlaceColor(colors?.bottom_bar ?? '#331410'),
            bottomBarIcon: new PlaceColor(colors?.bottom_bar_icon ?? '#FFFFFFCF'),
            bottomBarIconSelected: new PlaceColor(colors?.bottom_bar_icon_selected ?? '#f5a493'),
            findifyPrimary: new PlaceColor('#e85f4a'),
            findifySecondary: new PlaceColor('#601b2d'),
        }
    }
}
